export const JobsActionTypes = {
    API_RESPONSE_SUCCESS: '@@jobs/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@jobs/API_RESPONSE_ERROR',
    GET_JOBS: '@@jobs/GET_JOBS',
    START_JOBS_STREAM: '@@jobs/START_JOBS_STREAM',
    STOP_JOBS_STREAM: '@@jobs/STOP_JOBS_STREAM',
    JOB_STREAM_UPDATE: '@@jobs/JOB_STREAM_UPDATE',
    JOB_STREAM_DELETE: '@@jobs/JOB_STREAM_DELETE',
    JOB_STREAM_CONNECTED: '@@jobs/JOB_STREAM_CONNECTED',
    JOB_STREAM_DISCONNECTED: '@@jobs/JOB_STREAM_DISCONNECTED',
    JOB_STREAM_ERROR: '@@jobs/JOB_STREAM_ERROR',
};
